import { EXECUTORS } from '../hooks/actions/executors';
import type { ActionsReturnType } from '../hooks/actions/types';

import type { FullPostType, SharingModalFactoryProps } from './types';

export function useActionsFactory(props: SharingModalFactoryProps): ActionsReturnType {
	let recommendedGroup;
	const { platform, postType } = props;

	if ('recommendedGroup' in props) {
		recommendedGroup = props.recommendedGroup;
	}

	const fullPostType = `${platform}${recommendedGroup ? '_group' : ''}_${postType}` as FullPostType;

	return EXECUTORS[fullPostType](props);
}
